(() => {
  const init = () => {
    const popup = document.querySelector('.added-to-cart-popup');
    if (!popup || popup._addedToCartPopupInit) return;
    popup._addedToCartPopupInit = true;

    const mainProductContainer = popup.querySelector('.added-product__container');
    const mainTitleEl = mainProductContainer?.querySelector('.added-product__title');
    const mainPriceUnitEl = mainProductContainer?.querySelector('.price__unit');
    const mainPriceTotalEl = mainProductContainer?.querySelector('.price__total');
    const proceedButton = popup.querySelector('.add-to-cart-popup__proceed-to-cart');
    const relatedList = popup.querySelector('#related-products-list');

    // Snapshot of the original main container title/prices (before any mutation)
    const originalMainTitle = mainTitleEl ? mainTitleEl.innerHTML : '';
    const originalMainPriceUnit = mainPriceUnitEl ? mainPriceUnitEl.innerHTML : '';
    const originalMainPriceTotal = mainPriceTotalEl ? mainPriceTotalEl.innerHTML : '';

    const getMainVariantId = () => {
      const input = document.querySelector('product-form input[name="id"]');
      return input ? input.value : null;
    };

    const linesBySource = new Map();
    let extrasWrapper = null;

    const escape = (str) => String(str).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));

    const applyDiscount = (priceCents, discountValue, discountUnit) => {
      if (!discountValue) return priceCents;
      if (discountUnit === '%') return Math.round(priceCents * (1 - discountValue / 100));
      return Math.max(0, priceCents - discountValue * 100);
    };

    const formatMoney = (cents) => {
      const fmt = window.themeVariables?.settings?.moneyFormat
        || window.theme?.moneyFormat
        || window.Shopify?.money_format;

      if (window.Shopify?.formatMoney && fmt) {
        return window.Shopify.formatMoney(cents, fmt).replace(/([.,])00(\D|$)/, '$2').trim();
      }

      const amount = cents / 100;
      const hasCents = amount % 1 !== 0;
      return amount.toLocaleString('fr-FR', {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2
      }) + '\u202f€';
    };

    // Replace Shopify CDN size suffix (e.g. _300x.jpg → _small.jpg)
    const resizeShopifyImage = (url, size = 'small') => {
      if (!url) return url;
      return url.replace(/_(\d+x\d*|pico|icon|thumb|small|compact|medium|large|grande|original)(\.[a-z]+)(\?.*)?$/i, `_${size}$2$3`);
    };

    const readRowTitle = (row) => {
      const titleEl = row.querySelector('.multi-add__row-title');
      if (!titleEl) return '';
      const clone = titleEl.cloneNode(true);
      clone.querySelectorAll('.multi-add__row-subtitle').forEach(el => el.remove());
      return clone.innerText.trim();
    };

    const readRowData = (line, source) => {
      const row = source.querySelector(`.multi-add__row[data-variant-id="${line.variantId}"]`);
      if (!row) return null;

      // Prefer the product's featured_image (same source as popup's main container); fall back to the variant row image
      const productImage = row.dataset.productImage || '';
      const rawImage = row.querySelector('.multi-add__row-image img')?.getAttribute('src') || '';
      const image = productImage || resizeShopifyImage(rawImage, 'small');

      return {
        variantId: line.variantId,
        qty: line.qty,
        price: line.price,
        discount: line.discount,
        discountUnit: line.discountUnit,
        image,
        title: readRowTitle(row),
        url: row.querySelector('a[href]')?.getAttribute('href') || '#'
      };
    };

    const findMainLine = () => {
      const mainVariantId = getMainVariantId();
      if (!mainVariantId) return null;

      let result = null;
      linesBySource.forEach((lines, source) => {
        lines.forEach(line => {
          if (String(line.variantId) === String(mainVariantId)) {
            result = { ...line, _source: source };
          }
        });
      });
      return result;
    };

    const collectExtraItems = () => {
      const items = [];
      const mainVariantId = getMainVariantId();

      linesBySource.forEach((lines, source) => {
        lines.forEach(line => {
          if (mainVariantId && String(line.variantId) === String(mainVariantId)) return;

          const data = readRowData(line, source);
          if (data) items.push(data);
        });
      });
      return items;
    };

    const updateMainContainer = () => {
      if (!mainProductContainer) return;

      const mainLine = findMainLine();

      if (!mainLine || mainLine.qty <= 0) {
        // Restore original state
        if (mainTitleEl) mainTitleEl.innerHTML = originalMainTitle;
        if (mainPriceUnitEl) {
          mainPriceUnitEl.innerHTML = originalMainPriceUnit;
          mainPriceUnitEl.classList.remove('line-through');
        }
        if (mainPriceTotalEl) mainPriceTotalEl.innerHTML = originalMainPriceTotal;
        return;
      }

      const discountedUnit = applyDiscount(mainLine.price, mainLine.discount, mainLine.discountUnit);
      const totalPrice = discountedUnit * mainLine.qty;
      const totalCompare = mainLine.price * mainLine.qty;
      const hasSavings = totalCompare > totalPrice;

      // Update the "x N" qty span in the main title
      if (mainTitleEl) {
        const qtySpan = mainTitleEl.querySelector('.added-product__qty');
        if (qtySpan) qtySpan.textContent = `x ${mainLine.qty}`;
      }

      // Prices
      if (mainPriceUnitEl) {
        mainPriceUnitEl.innerHTML = formatMoney(totalCompare);
        mainPriceUnitEl.classList.toggle('line-through', hasSavings);
        mainPriceUnitEl.hidden = !hasSavings;
      }
      if (mainPriceTotalEl) {
        mainPriceTotalEl.innerHTML = formatMoney(totalPrice);
      }
    };

    const renderItem = (item) => {
      const discountedUnit = applyDiscount(item.price, item.discount, item.discountUnit);
      const totalPrice = discountedUnit * item.qty;
      const totalCompare = item.price * item.qty;
      const hasSavings = totalCompare > totalPrice;
      return `
        <div class="added-product__container">
          <div class="flex gap-2 align-start">
            <a href="${escape(item.url)}">
              <img class="product-img" src="${escape(item.image)}" alt="${escape(item.title)}" width="auto" height="auto">
            </a>
            <div class="added-product__info w-full">
              <div class="flex gap-2 justify-between align-start mb-8">
                <div class="added-product__title">
                  ${escape(item.title)}
                  <div class="added-product__qty">x ${item.qty}</div>
                </div>
                <div class="price text--right">
                  <div class="price__total text--bold">
                    ${formatMoney(totalPrice)}
                  </div>
                  ${hasSavings ? `<div class="price__unit text--subdued text--small line-through">${formatMoney(totalCompare)}</div>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    };

    const ensureExtrasWrapper = () => {
      if (extrasWrapper && extrasWrapper.isConnected) return;

      extrasWrapper = document.createElement('div');
      extrasWrapper.className = 'added-to-cart-popup__extras';

      // Insert before the proceed button so the button is always the LAST element
      // after all added products (main + extras)
      const anchor = proceedButton || relatedList || mainProductContainer?.nextSibling;
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(extrasWrapper, anchor);
      } else if (mainProductContainer?.parentNode) {
        mainProductContainer.parentNode.appendChild(extrasWrapper);
      }
    };

    const removeExtrasWrapper = () => {
      if (extrasWrapper && extrasWrapper.isConnected) extrasWrapper.remove();
      extrasWrapper = null;
    };

    const render = () => {
      updateMainContainer();

      const items = collectExtraItems();

      if (items.length === 0) {
        removeExtrasWrapper();
        return;
      }

      ensureExtrasWrapper();
      extrasWrapper.innerHTML = items.map(renderItem).join('');
    };

    document.addEventListener('multi-add-to-cart:change', (event) => {
      linesBySource.set(event.target, event.detail?.lines || []);
      render();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
